<template>
    <div v-if="emailInfo.isOpen" class="email-status">
        <CompassIcon type="success" size="extra-small" icon="success-circle-fill" />
        <span class="email-status-text">{{ $l10n.__(actualStatus) }}</span>
    </div>
</template>

<script>
export default {
    props: {
        emailInfo: {
            type: Object,
            required: true,
        },
    },
    computed: {
        actualStatus() {
            return this.emailInfo.isOpen ? this.$l10n.__('Email ouvert') : '';
        },
    },
};
</script>
<style lang="scss" scoped>
.email-status {
    display: flex;
    align-items: center;

    &-text {
        margin-left: 2px;
        color: var(--colors-common-text-standard-caption);
    }
}
</style>
